export const config = {
  apiEndpoint: import.meta.env.VITE_API_ENDPOINT || "https://api.preview.campnerd-changer-dev.com",
  defaultLanguage: import.meta.env.VITE_DEFAULT_LANGUAGE || "en",
  defaultAid: import.meta.env.VITE_DEFAULT_AID || "e4f1afde-65cd-432f-b38e-288af3919e93",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  posthogToken: import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN as string | undefined,
  posthogHost: import.meta.env.VITE_PUBLIC_POSTHOG_HOST as string | undefined,
  demoMode: import.meta.env.VITE_DEMO_MODE === "true",
} as const;
